/*  CheckoutSummaryMobile.jsx  */
import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const HEADER_OFFSET     = 80
const MOBILE_BREAKPOINT = 1024

export default function CheckoutSummaryMobile({ price, targetId }) {
  const [ratio, setRatio] = useState(0)
  const currency = localStorage.getItem('currency') || 'USD'

  /* ── scroll to checkout card ────────────────────────────── */
  const handleClick = useCallback(() => {
    const el = document.getElementById(targetId)
    if (!el) return
    const y = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
    window.scrollTo({ top: y, behavior: 'smooth' })
  }, [targetId])

  /* ── track visibility to slide/fade out ─────────────────── */
  useEffect(() => {
    const el = document.getElementById(targetId)
    if (!el) return

    const thresholds = Array.from({ length: 11 }, (_, i) => i / 10)
    const obs = new IntersectionObserver(
      ([entry]) => setRatio(entry.intersectionRatio),
      { rootMargin: `-${HEADER_OFFSET}px 0px 0px 0px`, threshold: thresholds }
    )
    obs.observe(el)
    return () => obs.disconnect()
  }, [targetId])

  if (typeof window !== 'undefined' && window.innerWidth >= MOBILE_BREAKPOINT)
    return null

  const progress = Math.min(ratio * 2, 1)   // 0‑0.5 → 0‑1
  const style = {
    transform: `translateY(${progress * 100}%)`,
    transition: 'transform 200ms ease-out, opacity 200ms ease-out',
  }

  return (
    <div
      style={style}
      className="fixed inset-x-0 bottom-0 z-50
                 flex justify-center
                 bg-[var(--bg-surface)] border-t border-[var(--border)]
                 px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.4)] lg:hidden"
    >   
      {/* stealth pill */}
      <div
        className="flex items-center gap-3 rounded-full
                   bg-[#202020] ring-1 ring-[var(--border)]
                   pl-4"
      >
        {/* price */}
        <span className="text-sm font-medium text-white whitespace-nowrap">
          ${price} {currency}
        </span>

        {/* CTA */}
        <button
          onClick={handleClick}
          className="flex p-2 items-center rounded-full
                     bg-[#00BAFF] px-4 text-sm font-semibold text-white
                     hover:bg-[#00a3e0] active:scale-95 transition"
        >
          <FontAwesomeIcon
            icon={faLock}
            className="h-4 w-4 text-white"
            style={{ opacity: 0.8 }}
          />
          <span className="ml-1">Secure</span>
          <span className="ml-1">Checkout</span>
          <svg
            aria-hidden
            className="ml-1 h-3.5 w-3.5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24" fill="none"
          >
            <path
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 9l7 7 7-7"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}

CheckoutSummaryMobile.propTypes = {
  price:    PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  targetId: PropTypes.string.isRequired,
}
